import Vue from "vue";
import {API_HOST} from "@/settings/server";
import axios from "axios";

class MailTrackingService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    get(uid) {
        return Vue.axios.get(`${API_HOST}/api/TrackMail`, {
            params: {
                id: uid
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }
}

export default new MailTrackingService()